import React from 'react';
import Button from '../../atoms/Button';
import Modal from '../../molecules/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../redux/modules/store';
import { ModalConfirmState } from '../../../redux/reducers/ModalReducer';
import { modalConfirmActions } from '../../../redux/modules/Actions';
import { Typography } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';

const ModalConfirm: React.FC = () => {
  const modalState: ModalConfirmState = useSelector((state: AppState) => state.modalConfirm);
  const { isDanger, isOpen, msg, title, type, primaryBtnText, callBack, isLoading } = modalState;
  const dispatch = useDispatch();
  const toggleModal = () => {
    if (isLoading) return;
    dispatch(modalConfirmActions.closeModal());
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.detail > 1) return;
    if (callBack) {
      callBack();
    }
    toggleModal();
  };

  return (
    <Modal open={isOpen} onClose={toggleModal} onBackdropClick={toggleModal} onEscapeKeyDown={toggleModal} surfaceClassName='u-mv-auto'>
      <Modal.Header hasCloseButton={false}>{title}</Modal.Header>
      <Modal.Content style={{ display: 'flex', alignItems: 'center' }}>
        {isDanger && (
          <Icon color='error' style={{ marginRight: 5 }}>
            error
          </Icon>
        )}
        <Typography color={isDanger ? 'error' : 'initial'}>{msg}</Typography>{' '}
      </Modal.Content>
      <Modal.Actions>
        <Button
          className={type === 'left' ? 'u-float-left' : ''}
          label='キャンセル'
          type='secondary'
          onClick={toggleModal}
          data-testid-e2e='btn-discard-filter-store'
          data-testid='btnDiscardFilterStore'
        />
        <Button
          label={primaryBtnText}
          isDanger={isDanger}
          onClick={handleClick}
          data-testid-e2e='btn-confirm-filter-store'
          data-testid='btnConfirmFilterStore'
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalConfirm;
